// Module
var code = "<div class=\"filled-orders-panel\">\r\n    <div class=\"filled-orders-panel-container-top\">\r\n        <rangeSelectPanel name='filledOrdersRangeSelect' />\r\n    </div>\r\n\r\n    <div class=\"filled-orders-panel-container-table\">\r\n        <terceraPanel name='windowPanelBodyQT' />\r\n    </div>\r\n</div>";
// Exports
export default code;